import React from 'react';
import PropTypes from 'prop-types';
import FullStory, { FullStoryAPI } from 'react-fullstory';
import { connect } from 'react-redux';

class FullStoryContainer extends React.Component {
  constructor(props) {
    super(props);
    this.sendFullStoryData = this.sendFullStoryData.bind(this);
  }

  componentDidMount() {
    this.sendFullStoryData();
  }

  componentDidUpdate() {
    this.sendFullStoryData();
  }

  sendFullStoryData() {
    const { auth } = this.props;
    if (
      this.props.config &&
      this.props.config.full_story_org_id &&
      auth &&
      auth.loggedIn &&
      auth.user
    ) {
      FullStoryAPI('setUserVars', {
        displayName: `User ID:${auth.user.id}`,
        userId: auth.user.id,
        userDeuceId: auth.user.id
      });
    }
  }

  render() {
    const { config } = this.props;
    return (config && config.full_story_org_id) ? <FullStory org={ config.full_story_org_id } /> : <div/>;
  }
}

FullStoryContainer.propTypes = {
  auth: PropTypes.shape({
    loggedIn: PropTypes.bool,
    user: PropTypes.object
  }),
  config: PropTypes.object
};

FullStoryContainer.defaultProps = {
  auth: {
    loggedIn: false,
    user: null
  },
  config: {
    full_story_org: ''
  }
};

const mapStateToProps = state => ({
  auth: state.auth,
  config: state.config.data
});

export default connect(
  mapStateToProps,
  null
)(FullStoryContainer);



// WEBPACK FOOTER //
// ./src/containers/FullStoryContainer.js